export const getHeadingContent = htmlString => {
  let textContent = htmlString.replace(/<[^>]+>/g, '');
  textContent = textContent.replace(/&nbsp;/g, ' ');
  textContent = textContent.replace(/\s+/g, ' ').trim();
  return textContent;
};
//# sourceMappingURL=get-heading-content.js.map